import { useMemo } from 'react'

import { useNavigationSettings } from 'hooks/useNavigationSettings'

export const useRemoveVisualEffectForPath = () => {
  const { isRatingPath, isRatingSettingsPath } = useNavigationSettings()

  return useMemo(() => {
    if (isRatingSettingsPath) {
      return false
    }

    return isRatingPath
  }, [isRatingPath, isRatingSettingsPath])
}
